import {Component, OnInit, Input} from '@angular/core';
import {Project} from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import {ProjectActivity} from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity';
import {ProjectHolder} from 'projects/app-misc/src/app/modules/project-misc/interfaces/project-holder';
import {MatDialog} from '@angular/material/dialog';
import {
  ProjectActivityService
} from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity.service';
import {ProjectInfoComponent} from '../../../project-info/project-info.component';
import * as moment from 'moment';
import {
  ProjectActivityDialogComponent
} from 'projects/app-misc/src/app/modules/project-misc/view/project-activity-dialog/project-activity-dialog.component';
import {ProjectFile} from 'projects/app-misc/src/app/modules/project-misc/data/project/project-file';
import {TrelloService} from 'projects/app-misc/src/app/modules/trello-misc/data/trello.service';
import {FileOpenerService} from 'projects/app-misc/src/app/modules/project-misc/utils/fileOpener.service';
import {FileService} from 'projects/core/src/lib/misc/data/file/file.service';

@Component({
  selector: 'app-mobile-project-activity',
  templateUrl: './mobile-project-activity.component.html',
  styleUrls: ['./mobile-project-activity.component.scss']
})
export class MobileProjectActivityComponent implements OnInit {

  project: Project;

  @Input()
  title: string;

  @Input()
  projectActivity: ProjectActivity;

  hours: string;


  constructor(
    protected fileService: FileService,
    protected fileOpenerService: FileOpenerService,
    protected projectHolder: ProjectHolder,
    private dialog: MatDialog,
    private projectActivityService: ProjectActivityService,
    protected trelloService: TrelloService,
    protected projectInfoComponent: ProjectInfoComponent
  ) {
    this.project = this.projectHolder.project
  }

  ngOnInit() {
    const now = moment()
    const b = moment(now).add(this.projectActivity.duration, 'seconds')
    this.hours = b.diff(now, 'hours') + 'h'
  }

  toggleReady() {
    if (this.projectActivity.startDate) {
      this.projectActivity.ready = !this.projectActivity.ready
      this.projectActivityService
        .saveProjectActivity({
          id: this.projectActivity.id,
          ready: this.projectActivity.ready
        })
        .subscribe(() => {
        })
    }

  }

  editProjectActivity(): void {
    this.projectActivityService.getActivityTypes().subscribe(types => {
      const activityTypes = types

      const dialogRef = this.dialog.open(ProjectActivityDialogComponent, {
        data: {projectActivity: this.projectActivity, buttonLabel: 'Save', types: activityTypes},
        disableClose: true
      });


      dialogRef.afterClosed().subscribe(result => {
        this.projectInfoComponent.updateActivities();
      });

    })
  }

  openFile(event, projectFile: ProjectFile) {
    event.stopPropagation()
    this.fileOpenerService.openFile(projectFile, this.projectActivity.files, true)
  }
}
